export default __webpack_public_path__ + "static/media/screen-6.45281203.jpg";